import('./bootstrap').catch(console.error)
